import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { NotifyService } from 'helpers';
import {
  PACKAGE_LIST_PARAMS_REQUEST,
  PACKAGE_LIST_STATE,
} from 'models/package';
import { call, put, takeLatest } from 'redux-saga/effects';
import { deletePackageApi, getPackageListApi } from 'services/package';
import { setGlobalLoading } from 'store/reducers/global';
import { setPackageListSuccess } from 'store/reducers/package';
import {
  DELETE_PACKAGE_REQUEST,
  GET_PACKAGE_LIST_REQUEST,
} from 'store/reducers/package/actionType';

function* getPackageRequest(
  action: PayloadAction<{
    params?: PACKAGE_LIST_PARAMS_REQUEST;
  }>
) {
  try {
    yield put(setGlobalLoading(true));
    const response: AxiosResponse<{ data: PACKAGE_LIST_STATE }> = yield call(
      getPackageListApi,
      action.payload.params
    );
    yield put(
      setPackageListSuccess({
        records: response.data.data.records,
        metadata: response.data.data.metadata,
      })
    );
    yield put(setGlobalLoading(false));
  } catch (error) {
    NotifyService.error(error);
    yield put(setGlobalLoading(false));
  }
}

function* deletePackage(
  action: PayloadAction<{
    id: string;
    onSuccess?: () => void;
  }>
) {
  try {
    yield call(deletePackageApi, action.payload.id);
    if (action.payload.onSuccess) action.payload.onSuccess();
  } catch (error: unknown) {
    NotifyService.error(error);
  }
}

function* packages() {
  yield takeLatest(GET_PACKAGE_LIST_REQUEST, getPackageRequest);
  yield takeLatest(DELETE_PACKAGE_REQUEST, deletePackage);
}

export default packages;
